import { createFileRoute } from "@tanstack/react-router";
import { NotBuiltYet } from "@/components/NotBuiltYet";

export const Route = createFileRoute("/status")({
  component: () => (
    <NotBuiltYet
      title="System status"
      backlogId="BL-008"
      description="A status page for the systems this service desk supports."
    />
  ),
});
